module.exports = __webpack_public_path__ + "img/bls-2.f8b5b58b.png";